<template
  ><div class="quote-container">
    <div class="title quote">
      <slot />
    </div>
  </div>
</template>

<style scoped>
.quote-container {
  display: flex;
  justify-content: center;
  width: 100%;
}
.quote {
  background: hsla(193, 100%, 55%, 0.7);
  padding: 10px;
  max-width: 90%;
  border-radius: 5px;
  text-align: center;
}
</style>

<script>
export default {
  name: "quote"
};
</script>
